/* CUSTOMERS */

import BasicLayout from '@/views/layouts/basic.vue';
import invoiceOverview from '@/views/invoices/list.vue';

/* ROUTER
-------------------------------------------------------------- */
export default {
  path: 'invoices',
  name: 'invoices',
  meta: {title: 'Facturen'},
  redirect: '/invoices/overzicht',
  component: BasicLayout,
  children: [
      // Overview routes
    {
      path: 'overzicht',
      name: 'invoices.overview',
      meta: {title: 'Facturen'},
      component: invoiceOverview,
    },
  ],
};
